import { connect } from 'react-redux';
import Feeds from './components/Feeds';
import { loadUser } from '../../redux/actions/user';
import {
  loadAvailableFeeds,
  loadFeeds,
  updateFeed,
  simpleAddFeed,
  deleteFeed,
  deleteEmptyFeed,
  createFeed,
  resetFeedStatus,
  consumeFeedData,
  createGlobalFeed,
  updateGlobalFeed,
  loadGlobalFeeds,
  deleteGlobalFeed,
  verifyAuth,
} from '../../redux/actions/feed';
import { selectFeeds } from '../../redux/selectors/feeds';
import { selectFoundTags } from '../../redux/selectors/tags';
import { loadFilters } from '../../redux/actions/filters';
import { resetTagSearch, searchForTags } from '../../redux/actions/tags';

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    feeds: selectFeeds(state),
    status: state.feed.status,
    globalFeedsStatus: state.feed.globalFeedsStatus,
    availableFeeds: state.feed.availableFeeds,
    foundTags: selectFoundTags(state),
    searchStatus: state.tags.searchStatus,
  };
};

const mapDispatchToProps = {
  loadUser,
  loadAvailableFeeds,
  loadFeeds,
  updateFeed,
  simpleAddFeed,
  deleteFeed,
  deleteEmptyFeed,
  createFeed,
  loadFilters,
  resetFeedStatus,
  consumeFeedData,
  createGlobalFeed,
  updateGlobalFeed,
  loadGlobalFeeds,
  deleteGlobalFeed,
  verifyAuth,
  resetTagSearch,
  searchForTags,
};

export default connect(mapStateToProps, mapDispatchToProps)(Feeds);
